<template>
  <div class="banner" id="COMPANY-INTROATION">
    <div class="cover">
      <div class="intro">
        <p>{{ intro1 }}</p>
        <p>{{ intro2 }}</p>
      </div>
      <div class="panel-box">
        <div class="panel">
          <div class="panel-item" v-for="(panel, index) in panels" :key="index">
            <div class="title">{{ panel.title }}</div>
            <div class="text" v-html="panel.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "banner",
  data() {
    return {
      intro1:
        "全景智联是京东科技的战略投资企业。作为行业内专业的城市微场景数据服务及整体解决方案提供商，数据服务和场景运营是我们的核心竞争力，也是支撑企业发展的驱动力。企业以AIoT技术为切入点，从事以“智慧社区”、“智慧街道”、“智慧园区”为核心的产品研发和项目交付，能够向客户提供包含基础建设、运营服务在内的全栈式解决方案。企业构建了完整且标准的项目建设、场景运营、数据服务体系，利用物联网技术赋能基层社会治理，通过定制化数据服务，助力政府部门优化治理模式；通过体系化运营，激发场景活力，为居民精准输送服务，发挥数据价值。",
      intro2:
        "企业不断布局物联网行业生态链，通过自身沉淀，积累了丰富的行业资质，已经获得大数据、人工智能、软件企业等系列技术类资质证书；作为高新技术企业，长期专注于技术创新和行业应用。自主研发的城市微场景大数据平台、社区大脑、可视化平台以及运营服务APP，能够全方位支撑基层治理服务工作。自研产品通过了ISO9001质量管理体系认证、中国国家强制性产品认证。目前企业的智慧场景和软件产品已经辐射含北京、上海、广州、深圳、武汉、合肥、青岛等18个城市，为不同行业客户高效赋能。",
      panels: [
        { title: "使命", text: "数据驱动治理 创新引领未来" },
        {
          title: "愿景",
          text: "最专业的城市微场景数据服务及<br/>整体解决方案提供商"
        },
        { title: "文化基因", text: "笃志  质朴  突破  方正" }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.cover {
  position: relative;
  width: 100%;
  height: 49.2rem;
  overflow: hidden;
  background: url("~@/assets/images/aboutUs/banner-bg.png") no-repeat top;
  background-size: 100% 100%;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(8, 8, 8, 0.27);
  }
  .intro {
    position: relative;
    width: 60rem;
    margin: 11.3rem auto 10.6rem;
    font-size: 1rem;
    color: #ffffff;
    line-height: 1.8rem;
    text-indent: 2em;
    text-align: justify;
    z-index: 100;
  }
  .panel-box {
    position: absolute;
    bottom: 4.5rem;
    left: 0;
    width: 100%;
    .panel {
      position: relative;
      padding: 0 11.5rem;
      display: flex;
      justify-content: center;
      z-index: 100;
      .panel-item {
        display: flex;
        align-items: center;
        flex-direction: column;
        // justify-content: center;
        width: 23.2rem;
        height: 10.5rem;
        margin: 0 0.65rem;
        color: #ffffff;
        text-align: center;
        background: url("~@/assets/images/aboutUs/panel-bg.png") no-repeat;
        transition: all 0.3s linear;
        &:hover {
          transform: translateY(-0.3rem);
          .title {
            &::before {
              top: 0;
              opacity: 1;
            }
            &::after {
              top: 0;
              opacity: 1;
            }
          }
        }
        .title {
          font-size: 0.9rem;
          margin-top: 2.3rem;
          &::before {
            content: "";
            position: relative;
            display: inline-block;
            width: 0.3rem;
            height: 0.8rem;
            top: -10px;
            left: -0.5rem;
            background-color: #ffffff;
            transform: skew(-10deg);
            opacity: 0;
            transition: all 0.3s linear;
          }
          &::after {
            content: "";
            position: relative;
            display: inline-block;
            width: 0.3rem;
            height: 0.8rem;
            top: 10px;
            right: -0.5rem;
            background-color: #ffffff;
            transform: skew(-10deg);
            opacity: 0;
            transition: all 0.3s linear;
          }
        }
        .text {
          margin-top: 1.2rem;
          font-size: 1rem;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
